import React from 'react';
import { useTranslation } from 'react-i18next';
import GoogleReviews from '../../components/GoogleReviews/GoogleReviews';

import './Laurels.css';

const Laurels = () => {
  const { t } = useTranslation();
  return (
    <div className="app__bg section__padding" id="awards">
      <div className="app__container">
        <div className="section__title">
          <h1 className="headtext__cormorant">{t('google')}</h1>
          <div className="section__title-accent" />
        </div>

        <div className="app__laurels_awards">
          <GoogleReviews />
        </div>
      </div>
    </div>
  );
};

export default Laurels;
